import alert from '@/plugins/alert'
import { FacilityProposal } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    pageText: '',
    itemsPerPage: 10,
    proposalSearchParams: {},
    totalItems: 0,
    proposals: []
  },
  actions: {
    async searchProposalList({ commit, state, dispatch }, query) {
      const proposalSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { proposalSearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.proposalSearchParams) {
        const proposalSearchParams = {
          ...state.proposalSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }

        const [totalItems, proposals] = await Promise.all([
          FacilityProposal.count(proposalSearchParams),
          FacilityProposal.search(proposalSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            proposals,
            totalItems,
            itemsPerPage,
            proposalSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async createProposal({ commit, state }, payload) {
      try {
        const created = await FacilityProposal.create(payload)
        commit('changeState', {
          proposals: [created, ...state.proposals]
        })
        alert.success('Gửi đề xuất thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async updateProposal({ commit }, { id, ...data }) {
      try {
        const updated = await FacilityProposal.update(id, data)
        commit('updateProposal', updated)
        alert.success('Cập nhật đề xuất thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async removeProposal({ commit }, id) {
      try {
        await FacilityProposal.remove(id)
        commit('removeProposal', id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateProposal(state, data) {
      state.proposals = state.proposals.map(p => (p.id === data.id ? data : p))
    },
    removeProposal(state, id) {
      state.proposals = state.proposals.filter(p => p.id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  }
}
